import React, { useState, useMemo, useCallback, useEffect } from "react";
import css from "./style.scss";
import uparrow from "../../assets/images/uparrow.svg";
import downarrow from "../../assets/images/downarrow.svg";
const AutocompleteDropdown = ({ items, label, placeholder, onSelect, required = false, value = null }) => {
    const [inputValue, setInputValue] = useState(value?.name || "");
    const [isOpen, setIsOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(value);

    useEffect(() => {
        if (value && value.name) {
            setInputValue(value.name);
            setSelectedItem(value);
        } else {
            setInputValue("");
            setSelectedItem(null);
        }
    }, [value]);

    const filteredItems = useMemo(() => {
        if (!inputValue) return items;
        return items.filter((item) =>
            item.name.toLowerCase().includes(inputValue.toLowerCase())
        );
    }, [inputValue, items]);

    return (
        <div className={css.autocompleteContainer}>
            <label className={css.autocompleteLabel}>
                {label}  {required && <span className={css.requiredAsterisk}> *</span>}
            </label>

            <div
                className={`${css.autocompleteInputWrapper} ${isOpen ? css.open : ""
                    }`}
            >
                <input
                    type="text"
                    value={inputValue}
                    onChange={(e) => {
                        setInputValue(e.target.value);
                        setIsOpen(true);
                    }}
                    onFocus={() => setIsOpen(true)}
                    onBlur={() => setTimeout(() => setIsOpen(false), 200)}
                    placeholder={placeholder}
                    className={css.autocompleteInput}
                />

                <button
                    className={css.dropdownArrow}
                    onClick={() => setIsOpen(!isOpen)}
                    type="button"
                >
                    <img
                        src={isOpen ? uparrow : downarrow}
                        alt="arrow"
                        className={css.arrowIcon}
                    />
                </button>

            </div>

            {isOpen && (
                <ul className={css.autocompleteList}>
                    {filteredItems.map((item) => (
                        <li
                            key={item.id}
                            className={css.autocompleteItem}
                            onMouseDown={() => {
                                setSelectedItem(item);
                                setInputValue(item.name);
                                setIsOpen(false);

                                if (onSelect) onSelect(item);
                            }}
                        >
                            {item.name}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default AutocompleteDropdown;

